enum TaskKanbanFilterType {
    ALL = 'all',
    MY_TASKS = 'my_tasks',
    MY_TEAMS = 'my_teams',
}

export default TaskKanbanFilterType;
